import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { ImageCarousel } from '../ImageCarousel';
import { carouselImages } from '../../data/salesContent';
export function InsideCarouselSection() {
  return <PageSection labelledBy="inside-title" className="bg-slate-950" data-id="element-121" data-mp="3tub0mk3mcq0x">
      <SectionHeading id="inside-title" title="Mirá todo lo que tenés adentro" data-id="element-122" data-mp="3oylx65ohaozc" />
      <div className="mt-8" data-id="element-123" data-mp="316x3olzx7ugt">
        <ImageCarousel images={carouselImages} label="Páginas de muestra del kit" data-id="element-124" data-mp="31887gltd927x" />
      </div>
    </PageSection>;
}